module.exports = __webpack_public_path__ + "static/media/sachin-2.e9f66aea.jpg";